import { theme } from '@sbv-clients/ui-shared';

export const authLabelSx = {
  fontWeight: 700,
  color: theme.text.primary,
};

export const authFieldSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.background.surface,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${theme.colors.primary.border}`,
  },
};

export const authButtonSx = {
  fontWeight: 700,
};
